import { ConnectionDetails, convertConnectionToDetails, handleError, queryInput } from '../../../utils/custom';
import { Flag, FlagWithTrip, FlagWithTripConnection, FlagWithTripConnectionInput } from '../../../models/gen/graphql';
import { SearchFlagsDocument, SearchFlagsWithTripDocument } from '@/api/queries';

import { GraphApiResponse } from '../../core';
import createGraphApiHook from '../../../hooks/createGraphApiHook';
import graphApi from '../..';

export type SearchFlagGraphApiResponse = GraphApiResponse<typeof SearchFlagsWithTripDocument>;
export const searchFlagResponseSelector = (res: SearchFlagGraphApiResponse): ConnectionDetails<FlagWithTrip> =>
  convertConnectionToDetails(res?.searchFlags?.flagWithTripConnection as FlagWithTripConnection);

const [, runRefetchSearchFlag] = graphApi(SearchFlagsWithTripDocument, {
  onError: (res: SearchFlagGraphApiResponse): void => handleError(res, { notification: { title: 'Search Flag' } }),
});

export const getFlagByTripId = async (tripId: string): Promise<FlagWithTrip[]> => {
  const input: FlagWithTripConnectionInput = {
    first: 1000,
    after: null,
    query: [{ tripId: queryInput(tripId) }],
  };

  const res = await runRefetchSearchFlag({ input });
  const conn = searchFlagResponseSelector(res);

  return conn?.rows || [];
};
export const useGetFlagForTrip = createGraphApiHook(getFlagByTripId);

const [, runSearchFlags] = graphApi(SearchFlagsDocument);

export const searchFlags = async () => {
  const res = await runSearchFlags({ input: { first: 1000, after: null } });
  return res.searchFlags.flagConnection.edges.map(({ node }) => node as Flag) || ([] as Flag[]);
};
